import { QueryClient, queryOptions, useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { BillingInfos } from '@teetsh/app/src/types/user';
import parseISO from '@teetsh/app/src/utils/time/parseISO';
import { useQueryData } from 'queries/useQueryData';
import { requireUserSession } from 'queries/requireUserSession';

export const BILLING_INFO_KEY = 'billingInfos';

function billingInfoQuery() {
  return queryOptions({
    queryKey: [BILLING_INFO_KEY],
    queryFn: () =>
      request('/billing/infos', {
        method: 'GET',
      }).then<BillingInfos>(res => {
        const result = {
          ...res,
          expirationDate: res.expirationDate
            ? parseISO(res.expirationDate)
            : undefined,
          paymentHistory: (res.paymentHistory || []).map(p => ({
            ...p,
            date: parseISO(p.date),
          })),
        };
        if (res.nextPlan) {
          const nextPlanObj = res.nextPlan;
          return {
            ...result,
            nextPlan: {
              ...nextPlanObj,
              expirationDate: parseISO(nextPlanObj.expirationDate),
            },
          };
        }
        return result;
      }),
    refetchOnWindowFocus: false,
  });
}

export const loader = (queryClient: QueryClient) => async () => {
  await requireUserSession();
  return queryClient.ensureQueryData(billingInfoQuery());
};

export function useBillingInfos() {
  return useQuery(billingInfoQuery());
}

export function useBillingInfosData() {
  return useQueryData(billingInfoQuery());
}
